export default () => {
    const buttonContainer = document.querySelectorAll("*[invite-members-btns]");
    if (buttonContainer.length === 0)
        return;
    import(/* webpackChunkName: "invite member module" */ "../classes/inviteMemberClass")
        .then(({ default: InviteMember }) => {
        new InviteMember();
    })
        .catch(() => "An error with invite member component occurred");
};
